export const worldJa = {
  'world.seo.title': '世界',
  'world.seo.description':
    'Grymwyddの対話型地図を探索 — その王国、廃墟、伝説の舞台を2D地図と回転可能な3D地球儀で。',
  'world.heading': '世界',
  'world.intro':
    '永遠の薄暮を辿れ。この地図は入れ子式の視点を想定して構築されている — 世界全体からひとつのダンジョンまで、段階的にズームインできる。現在は最上層のみが対話型。より深い層は領域の描画が進むにつれ開放予定。',

  'world.viewMode.label': '地図表示モード',
  'world.viewMode.map2d': '2D地図',
  'world.viewMode.globe3d': '3D地球儀',

  'world.gazetteer.navLabel': '場所とシーン',
  'world.gazetteer.heading': '地名辞典',
  'world.gazetteer.sampleNotice':
    'サンプル地点を表示中 — 地図製作者の本来の測量はまだ記録されていません。',
  'world.gazetteer.error': '地図の書庫に到達できませんでした。',

  'world.loading.atlas': '地図を広げている……',
  'world.loading.globe': '世界を回転させている……',

  'world.layersActive': '{active}/{total}個のレイヤーが有効です。',
  'world.globeHint':
    'ドラッグで回転（探索中はオートスピン停止、1分間非アクティブで再開）。スクロールでズームイン。ヘックスにカーソルを合わせるとキャンペーンが表示され、クリックで進入。',
  'world.webglUnavailable':
    '3D地球儀にはWebGLが必要ですが、このブラウザでは利用できません — 2D地図を表示しています。',

  'world.campaign.capitalRegion': '王都圏',
  'world.campaign.territory': 'キャンペーン領域',
  'world.campaign.enter': 'キャンペーンに進入',
  'world.campaign.stay': '軌道に留まる',

  'world.layers.heading': 'マップレイヤー',
  'world.layers.gmBadge': 'GM',
  'world.layers.gmRequired': 'ゲームマスターの役割が必要です。',

  'world.marker.sampleBadge': 'サンプルデータ',
  'world.marker.viewInEncyclopedia': '事典で表示',
  'world.marker.placeholderNote':
    'これはプレースホルダーサイトです — 背景設定が記述されると事典にリンクされます。',

  'world.map2d.ariaLabel': '対話型オーバーワールドマップ',
  'world.map2d.noOverworld': 'オーバーワールド地図がまだ描かれていません — 虚無を表示中',

  'world.globe.hint.enter': 'Enter ▸',
  'world.globe.hint.open': 'Open ▸',
  'world.globe.hint.claim': 'Claim ▸',
  'world.globe.uncharted': '未踏の地',
  'world.globe.unchartedBlurb':
    'この永遠の薄暮のヘックスはまだどのキャンペーンにも領有されていません。最初の旗を立ててください。',
  'world.globe.capitalLabel': 'Grymwyrd',
} as const
